const initialState = {
    loading: false,
    dashboard: {},
    myMomentos: [],
    singleMomento: {},
    momentoRequests: [],
    familyCodes: [],
    pendingRequests: 0,
};

export default function MomentosReducers(
    state = initialState,
    { type, payload }
) {
    switch (type) {
        case "ADD_MANAGER_RATING":
            return {
                ...state,
                myMomentos: state.myMomentos.map((items) =>
                    items.id == payload
                        ? { ...items, managerRating: true }
                        : items
                ),
            };
        case "MOMENTO_LOADER":
            return {
                ...state,
                loading: payload,
            };
        case "MY_MOMENTOS":
            return {
                ...state,
                myMomentos: payload,
            };
        case "MY_MOMENTOS_MORE":
            return {
                ...state,
                myMomentos: [...state.myMomentos, ...payload],
            };
        case "SINGLE_MOMENTO":
            return {
                ...state,
                singleMomento: payload,
            };
        case "MOMENTOS_REQUESTS":
            return {
                ...state,
                momentoRequests: payload,
            };
        case "FAMILY_QR_CODES":
            return {
                ...state,
                familyCodes: payload,
            };
        case "DASHBOARD_STATS":
            return {
                ...state,
                dashboard: payload,
            };
        case "PENDING_REQUESTS":
            return {
                ...state,
                pendingRequests: payload,
            };
        default:
            return { ...state };
    }
}
